/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

//require('./bootstrap');
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
//import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { library, config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
//import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Vuelidate from 'vuelidate';
import VueCarousel from 'vue-carousel';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

config.autoAddCss = false

library.add(fas)

window.Vue = require('vue');
window.axios = require('axios');

Vue.use(Vuelidate)
Vue.use(VueAxios, axios)
Vue.use(VueCarousel)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Loading);
import Vuetify from "../plugins/vuetify";

import VueGTM from '@gtm-support/vue2-gtm';


Vue.use(VueGTM, {

        id: 'GTM-K74HJP2',
        defer: false,
        compatibility: false,
        nonce: '',
        enabled: true,
        debug: true,
        loadScript: true,
        ignoredViews: ['homepage'],
        trackOnNextTick: false,

})



/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/RegisterComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))


//Vue.component('resultado-busqueda-component', require('./components/resultadobusqueda/RestultadoBusqueda').default);
Vue.component('resultado-busqueda-component', function (resolve, reject) {
   require(['./components/resultadobusqueda/RestultadoBusqueda'],resolve)
})


//Vue.component('loading', Loading);



/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

resultadoBusqueda();

function resultadoBusqueda() {
    new Vue({

        vuetify: Vuetify,
        el: '#resultado-buqueda',
    });

}









